import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pop from '@/mixin/pop';
var 已中奖素材 = window.setting.抽奖模块.已中奖素材;
export default {
  mixins: [pop],
  props: {
    config: {
      type: Object,
      "default": function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      lotteryHit: null,
      // 抽中奖动画对象
      isShowHitAnimation: false
    };
  },
  computed: {
    // 中奖映射表
    lotteryHitMaterial: function lotteryHitMaterial() {
      return 已中奖素材.reduce(function (total, cur) {
        return _objectSpread(_objectSpread({}, total), {}, _defineProperty({}, cur.奖品id, cur.文案));
      }, {});
    }
  },
  watch: {
    value: {
      handler: function handler(val) {
        var _this = this;

        if (val) {
          // 展示动画
          this.isShowHitAnimation = true;
          this.$nextTick(function () {
            _this.playHitAnimation();
          });
        }
      }
    }
  },
  methods: {
    share: function share() {
      var _this$config = this.config,
          result = _this$config.result,
          lottery = _this$config.lottery;

      if (result) {
        this.eventBus.$emit('launchShare', {
          type: 'lottery',
          prizeName: lottery.lotter_name,
          prizeIcon: lottery.lotter_url
        }, this.close);
      } else {
        this.eventBus.$emit('launchShare', {
          type: 'bless',
          prizeIcon: lottery.分享图
        }, this.close);
      }
    },
    // 抽中奖
    playHitAnimation: function playHitAnimation() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.lotteryHit = window.bodymovin.loadAnimation({
                  // animationData,
                  path: 'https://m.film.qq.com/static/cny2022-sport/lottie/data.json',
                  loop: true,
                  autoplay: true,
                  renderer: 'svg',
                  // 渲染方式，有"html"、"canvas"和"svg"三种
                  container: _this2.$refs.lotteryHit
                });

                _this2.lotteryHit.addEventListener('loopComplete', function () {
                  // 停止动画
                  _this2.lotteryHit.stop(); // 隐藏动画弹层


                  _this2.isShowHitAnimation = false;
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};